import React, { useEffect, useState, useMemo } from "react";
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim";

const ParticlesBg = () => {
  const [init, setInit] = useState(false);

  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadSlim(engine);
    }).then(() => setInit(true));
  }, []);

  const options = useMemo(
    () => ({
      fullScreen: false,
      fpsLimit: 60,
      particles: {
        number: { value: 40, density: { enable: true, area: 900 } },
        color: { value: ["#e62429", "#c8a200", "#11abb0"] },
        shape: { type: "circle" },
        opacity: {
          value: { min: 0.15, max: 0.4 },
          animation: { enable: true, speed: 0.8, minimumValue: 0.1, sync: false },
        },
        size: {
          value: { min: 1, max: 3 },
          animation: { enable: true, speed: 2, minimumValue: 0.5, sync: false },
        },
        links: {
          enable: true,
          distance: 140,
          color: "#e62429",
          opacity: 0.12,
          width: 1,
        },
        move: {
          enable: true,
          speed: 0.6,
          direction: "none",
          random: true,
          straight: false,
          outModes: { default: "out" },
        },
      },
      interactivity: {
        detectsOn: "canvas",
        events: {
          onHover: { enable: true, mode: "grab" },
          onClick: { enable: true, mode: "push" },
        },
        modes: {
          grab: { distance: 160, links: { opacity: 0.3, color: "#c8a200" } },
          push: { quantity: 2 },
        },
      },
      detectRetina: true,
    }),
    []
  );

  if (!init) return null;

  return (
    <Particles
      id="hero-particles"
      className="particles-bg"
      options={options}
    />
  );
};

export default ParticlesBg;
